import { useData } from "@hooks/useData";
import { byoSettingGetNameById } from "@core/api";

type Response = {
    name: string;
};

async function getByoSettingNameById(id: string): Promise<string> {
    if (!id) return '';
    try {
        const response: Response = await byoSettingGetNameById(id);

        return `${response?.name}`;
    } catch (error) {
        console.error(`Error fetching BYO setting name by ID: ${error}`);
        return '';
    }
}

export function useByoSettingNameById(id: string) {
    return useData('', getByoSettingNameById, id);
}